import { FC, useState, ChangeEvent, useEffect } from 'react';
import { useStyles } from './styles';
import { Grid, Paper, Tabs, Tab, IconButton } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import { AdminDataForm } from './SubForms/AdminDataForm';
import { useHistory } from 'react-router-dom';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { handleCompanyUrl } from 'utils/organizationUtils';

function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

export const AdminForm: FC<any> = ({ type }) => {
  const classes = useStyles();
  const [value, setValue] = useState<string>('one');
  const history = useHistory();

  const [currentUser, setCurrentUser] = useState<any>(() => {
    if (type === 'add') {
      localStorage.removeItem('ClickedUser');
      return null;
    }
    return JSON.parse(localStorage.getItem('ClickedUser') as string);
  });

  useEffect(() => {
    if (type !== 'add') {
      const timeoutId = setTimeout(() => {
        setCurrentUser(JSON.parse(localStorage.getItem('ClickedUser') as string));
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
    return undefined;
  }, [type]);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <div className={classes.left}>
          <IconButton
            onClick={() => {
              history.push(handleCompanyUrl('/admins'));
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Tabs value={value} indicatorColor='secondary' textColor='secondary' onChange={handleChange}>
            <Tab
              value='one'
              label={currentUser?.uid ? `Admin: ${currentUser.uid}` : 'Admin'}
              {...a11yProps('one')}
              className={classes.label}
            />
          </Tabs>
        </div>
        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <AdminDataForm type={type} currentUserData={currentUser} />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
};
